import React from 'react';

export default ({ record }) => {
  return (
    <span>
      Service Consultant
      {record ? `: ${record.full_name}` : ''}
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/containers/ServiceConsultant/Title.js